var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCircircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.225,
    height: 93.406,
    viewBox: "0 0 93.225 93.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 76.064,
    height: 76.32,
    fill: "#f7707d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(-130.104 -202.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 149.857, 202.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43743",
    "data-name": "Path 43743",
    d: "M75.294,29.61q.33,2.079.661,4.157c.713,11.579-2,22.036-10.247,30.586C55.022,75.439,41.814,78.663,27.39,74.688,12.579,70.606,3.628,60.155.5,45.1-.254,41.442.138,37.55,0,33.768q.332-2.079.661-4.158C2.394,22.5,6.089,16.462,10.808,10.981l4.973-4.147C30.59-2.3,45.4-2.249,60.217,6.819l4.931,4.162C69.877,16.457,73.57,22.5,75.294,29.61M18.9,29.478A7.815,7.815,0,0,0,17.428,33.7c-1.854,9.212,1.194,16.576,8.733,21.949a20.485,20.485,0,0,0,23.63.005c7.558-5.367,10.575-12.738,8.753-21.941a7.538,7.538,0,0,0-1.491-4.238c-3.654-8.291-10.291-12.41-19.073-12.4S22.536,21.152,18.9,29.478",
    transform: "translate(0 0)",
    fill: "#f7707d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircircle);
export default __webpack_public_path__ + "static/media/red-circircle.5c69b408c30ca39b11bb06daecb700f9.svg";
export { ForwardRef as ReactComponent };